import {Head, useForm} from '@inertiajs/react';
import {PageProps} from '@/types';
import {FormEventHandler} from "react";
import InputLabel from "@/Components/Base/InputLabel";
import TextInput from "@/Components/Base/TextInput";
import InputError from "@/Components/Base/InputError";
import PrimaryButton from "@/Components/Base/PrimaryButton";
import GuestLayout from "@/Layouts/GuestLayout";

type Props = PageProps<{
    status: string;
    identifier?: string;
    pin?: string;
}>;

export default function JoinSession(props: Props) {
    const {data, setData, post, processing, errors} = useForm({
        identifier: props.identifier || '',
        pin: props.pin || '',
    });

    const submit: FormEventHandler = (e) => {
        e.preventDefault();

        post(route('joinSession'));
    };

    return (
        <GuestLayout>
            <Head title="Log in"/>

            {props.status && <div className="mb-4 font-medium text-sm text-green-600">{props.status}</div>}

            <section>
                <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
                    <a href="#" className="flex items-center mb-6 text-2xl font-semibold">
                        TrackMate
                    </a>

                    <div className="w-full bg-white dark:bg-gray-800 rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
                        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                            <h1 className="text-xl font-bold leading-tight tracking-tight md:text-2xl">
                                Session beitreten
                            </h1>

                            <form onSubmit={submit}>
                                <div>
                                    <InputLabel htmlFor="identifier" value="Identifier"/>

                                    <TextInput
                                        id="identifier"
                                        name="identifier"
                                        value={data.identifier}
                                        className="mt-1 block w-full"
                                        isFocused={true}
                                        autoComplete={"off"}
                                        autoCorrect={"off"}
                                        autoCapitalize={"off"}
                                        onChange={(e) => setData('identifier', e.target.value)}
                                    />

                                    <InputError message={errors.identifier} className="mt-2"/>
                                </div>

                                <div className="mt-4">
                                    <InputLabel htmlFor="pin" value="Pin"/>

                                    <TextInput
                                        id="pin"
                                        name="pin"
                                        value={data.pin}
                                        className="mt-1 block w-full"
                                        autoComplete={"off"}
                                        autoCorrect={"off"}
                                        autoCapitalize={"off"}
                                        onChange={(e) => setData('pin', e.target.value)}
                                    />

                                    <InputError message={errors.pin} className="mt-2"/>
                                </div>

                                <div className="flex items-center justify-end mt-4">
                                    <PrimaryButton className="ms-4" disabled={processing}>
                                        Join
                                    </PrimaryButton>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </GuestLayout>
    );
}
